import { useMemo } from 'react';

import type {
  IUseValueChainInteractionStateParams,
  IUseValueChainInteractionStateReturn,
} from '../interfaces/IUseValueChainInteractionState';

const useValueChainInteractionState = ({
  isAccessDisabled,
  isDraftReviewMode,
  isScenarioViewMode,
  openAICardPanel,
  isLoading,
  isLocationsCountriesFetching,
  isUpdateBoardColumnLoading,
  isCreateBoardColumnLoading,
  isDeleteBoardColumnLoading,
  isBusinessModelFetching,
  isEnumLoading,
  isCreateLogicalConnectionLoading,
  isUpdateLogicalConnectionLoading,
  isDeleteLogicalConnectionLoading,
  isCreateSupplierConnectionLoading,
  isUpdateSupplierConnectionLoading,
  isDeleteSupplierConnectionLoading,
  isCreateServiceConnectionLoading,
  isUpdateServiceConnectionLoading,
  isDeleteServiceConnectionLoading,
  isCreateManufactureConnectionLoading,
  isUpdateManufactureConnectionLoading,
  isDeleteManufactureConnectionLoading,
  isDraftUnitsLoading,
  isApplyDraftSessionLoading,
  isDeleteSessionLoading,
  isActivateAgentSessionLoading,
  isTransitioningToDraftReview,
  isBoardRefetchingAfterApply,
  isDraftBoardBuilding,
}: IUseValueChainInteractionStateParams): IUseValueChainInteractionStateReturn => useMemo(() => {
  const isBoardEditingEnabled = !isAccessDisabled && !isDraftReviewMode && !isScenarioViewMode;
  const isNodeEditingEnabled = isBoardEditingEnabled && !openAICardPanel;
  const isEdgeChangesEnabled = !isAccessDisabled;
  const isBoardContentHidden = isTransitioningToDraftReview
    || isBoardRefetchingAfterApply
    || isDraftBoardBuilding;
  const isValueChainLoading = isLoading
    || isLocationsCountriesFetching
    || isUpdateBoardColumnLoading
    || isCreateBoardColumnLoading
    || isDeleteBoardColumnLoading
    || isBusinessModelFetching
    || isEnumLoading
    || isCreateLogicalConnectionLoading
    || isUpdateLogicalConnectionLoading
    || isDeleteLogicalConnectionLoading
    || isCreateSupplierConnectionLoading
    || isUpdateSupplierConnectionLoading
    || isDeleteSupplierConnectionLoading
    || isCreateServiceConnectionLoading
    || isUpdateServiceConnectionLoading
    || isDeleteServiceConnectionLoading
    || isCreateManufactureConnectionLoading
    || isUpdateManufactureConnectionLoading
    || isDeleteManufactureConnectionLoading
    || isDraftUnitsLoading
    || isApplyDraftSessionLoading
    || isDeleteSessionLoading
    || isActivateAgentSessionLoading
    || isBoardContentHidden;

  return {
    isBoardEditingEnabled,
    isNodeEditingEnabled,
    isEdgeChangesEnabled,
    isValueChainLoading,
    isBoardContentHidden,
  };
}, [
  isAccessDisabled,
  isActivateAgentSessionLoading,
  isApplyDraftSessionLoading,
  isBoardRefetchingAfterApply,
  isBusinessModelFetching,
  isCreateBoardColumnLoading,
  isCreateLogicalConnectionLoading,
  isCreateServiceConnectionLoading,
  isCreateSupplierConnectionLoading,
  isCreateManufactureConnectionLoading,
  isDeleteBoardColumnLoading,
  isDeleteLogicalConnectionLoading,
  isDeleteServiceConnectionLoading,
  isDeleteManufactureConnectionLoading,
  isDeleteSessionLoading,
  isDeleteSupplierConnectionLoading,
  isDraftBoardBuilding,
  isDraftReviewMode,
  isDraftUnitsLoading,
  isEnumLoading,
  isLoading,
  isLocationsCountriesFetching,
  isScenarioViewMode,
  isTransitioningToDraftReview,
  isUpdateBoardColumnLoading,
  isUpdateLogicalConnectionLoading,
  isUpdateServiceConnectionLoading,
  isUpdateManufactureConnectionLoading,
  isUpdateSupplierConnectionLoading,
  openAICardPanel,
]);

export default useValueChainInteractionState;
